export enum PdfReaderScreenNames {
  MAIN = 'pdf-reader-nav',
  READER = 'pdf-reader',
}
